<script setup>
import onboarding from "./onboarding.json";

const meta_tags = onboarding.meta_tags;

definePageMeta({
  layout: "laravel-layout",
});

useHead({
  title: meta_tags.title,
  meta: meta_tags.meta,
});
</script>

<template>
  <section class="lg:text-center py-10 px-4 text-[#575365]">
    <div class="max-w-screen-xl mx-auto px-4 lg:pt-10 lg:pb-16">
      <h1 class="text-3xl lg:text-5xl font-bold">
        <WrGradientText>
          We Have a Highly Structured Onboarding Process.
        </WrGradientText>
      </h1>
      <p class="text-lg text-[#6d6685] tracking-[0.5px]">
        You’ll get a step-by-step guide to help you set things up and get
        started
      </p>
    </div>
  </section>

  <WrOnboarding :onboarding="onboarding.onboarding" />

  <section class="relative z-10 py-8">
    <div class="max-w-screen-xl mx-auto px-4">
      <h2 class="text-center">
        <WrGradientText
          text="Trusted for excellence and efficiency"
          append-class="text-3xl lg:text-[48px]"
        />
        <p class="text-lg text-[var(--foreground)]">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <WrTestimonialCardCarousel class="mt-12" />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
        >View All</WrButton
      >
    </div>
  </section>
</template>
